import { useState, useEffect } from "react";
import apiUrls from "../../apiUrls";
import { AnnouncementDto } from "./types";
import { MANAGE_SITE_URL } from 'gatsby-env-variables-fork';

const url =
  typeof window !== "undefined"
    ? `${MANAGE_SITE_URL}${apiUrls.getAnnouncements}`
    : "";

const useAnnouncementsData = () => {
  const [data, setData] = useState<AnnouncementDto[]>([]);
  const [isFetching, setIsFetching] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    async function fetchData() {
      const result = await fetch(url)
        .then((res) => {
          if (!res.ok) {
            throw new Error(res.statusText)
          }
          return res.json();
        })
        .catch((err) => {
          setIsFetching(false);
          setIsError(true);
          console.error("Failed to fetch announcements", err);
        });
      if (result) {
        setData(result.announcements);
        setIsFetching(false);
      }
    }

    fetchData();
  }, []);

  return { isFetching, data, isError };
};

export default useAnnouncementsData;
